import {
  FETCH_PACKAGES,
  FETCH_PACKAGES_FAILURE,
  FETCH_PACKAGES_SUCCESS,
  //
  SET_CART_DATA,
  //
  TOGGLE_CONFIRM_MODAL,
  //
  CREATE_PAYMENT,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  //
  ADD_TRANSACTION,
  ADD_TRANSACTION_SUCCESS,
  ADD_TRANSACTION_FAILURE,
} from "./constants";

//
export const fetchPackages = (payload) => ({
  type: FETCH_PACKAGES,
  payload,
});
export const fetchPackagesSuccess = (payload) => ({
  type: FETCH_PACKAGES_SUCCESS,
  payload,
});
export const fetchPackagesFailure = (payload) => ({
  type: FETCH_PACKAGES_FAILURE,
  payload,
});
//
export const setCartData = (payload) => ({
  type: SET_CART_DATA,
  payload,
});

//
export const toggleConfirmModal = (payload) => ({
  type: TOGGLE_CONFIRM_MODAL,
  payload,
});
//
export const createPayment = (payload) => ({
  type: CREATE_PAYMENT,
  payload,
});
export const createPaymentSuccess = (payload) => ({
  type: CREATE_PAYMENT_SUCCESS,
  payload,
});
export const createPaymentFailure = (payload) => ({
  type: CREATE_PAYMENT_FAILURE,
  payload,
});
//
export const addTransaction = (payload) => ({
  type: ADD_TRANSACTION,
  payload,
});
export const addTransactionSuccess = (payload) => ({
  type: ADD_TRANSACTION_SUCCESS,
  payload,
});
export const addTransactionFailure = (payload) => ({
  type: ADD_TRANSACTION_FAILURE,
  payload,
});
